import PropTypes from "prop-types";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";

const STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "open", label: "Open" },
  { value: "acknowledged", label: "Acknowledged" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_on_customer", label: "Waiting" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
];

const PRIORITY_OPTIONS = [
  { value: "", label: "All Priorities" },
  { value: "critical", label: "Critical" },
  { value: "high", label: "High" },
  { value: "medium", label: "Medium" },
  { value: "low", label: "Low" },
];

const MODULE_OPTIONS = [
  { value: "", label: "All Categories" },
  { value: "stock_management", label: "Stock Management" },
  { value: "qr_serial", label: "QR Code / Verification" },
  { value: "dealers", label: "Dealer Management" },
  { value: "campaigns", label: "Campaigns & Loyalty" },
  { value: "reports", label: "Reports & Analytics" },
  { value: "account_billing", label: "Account & Settings" },
  { value: "other", label: "Other" },
];

const TicketFilters = ({
  status,
  priority,
  smartkoodModule,
  assignee,
  agents = [],
  onStatusChange,
  onPriorityChange,
  onModuleChange,
  onAssigneeChange,
  onClearAll,
}) => {
  const hasFilters = status || priority || smartkoodModule || assignee;

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "12px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          alignItems: "flex-end",
        }}
      >
        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            label="Status"
            onChange={(e) => onStatusChange(e.target.value)}
          >
            {STATUS_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Priority</InputLabel>
          <Select
            value={priority}
            label="Priority"
            onChange={(e) => onPriorityChange(e.target.value)}
          >
            {PRIORITY_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Category</InputLabel>
          <Select
            value={smartkoodModule}
            label="Category"
            onChange={(e) => onModuleChange(e.target.value)}
          >
            {MODULE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 160 }}>
          <InputLabel>Assigned Agent</InputLabel>
          <Select
            value={assignee}
            label="Assigned Agent"
            onChange={(e) => onAssigneeChange(e.target.value)}
          >
            <MenuItem value="">All Agents</MenuItem>
            <MenuItem value="unassigned">Unassigned</MenuItem>
            {agents.map((agent) => (
              <MenuItem key={agent.id} value={agent.id}>
                {agent.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {hasFilters && (
          <Button
            size="small"
            startIcon={<ClearIcon />}
            onClick={onClearAll}
            sx={{
              textTransform: "none",
              color: "#6b778c",
              fontSize: 13,
            }}
          >
            Clear all
          </Button>
        )}
      </Box>
    </Box>
  );
};

TicketFilters.propTypes = {
  status: PropTypes.string,
  priority: PropTypes.string,
  smartkoodModule: PropTypes.string,
  assignee: PropTypes.string,
  agents: PropTypes.array,
  onStatusChange: PropTypes.func.isRequired,
  onPriorityChange: PropTypes.func.isRequired,
  onModuleChange: PropTypes.func.isRequired,
  onAssigneeChange: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default TicketFilters;
